<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close"
                  @click="$emit('close')"
                  aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Cancelar contrato
          </h4>
        </div>

        <div v-if="hasPaidValue" class="modal-body">
          <div class="alert alert-danger">
            Não é possível cancelar o contrato pois este possui valores pagos
          </div>
        </div>

        <div v-else class="modal-body">
          <p>Motivo de cancelamento</p>
          <div v-if="inputError" class="alert alert-danger">
            {{ inputError }}
          </div>
          <input @click="inputError = null" class="form-input" type="text" v-model="observations">
        </div>

        <div class="modal-footer">
          <button v-if="!hasPaidValue" class="btn btn-danger" @click="executeCancel">
            Cancelar o contrato
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ContractsService from 'services/ContractsService';

export default {
  props: {
    contract: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      observations: null,
      inputError: null,
    };
  },
  computed: {
    hasPaidValue() {
      return !!parseFloat(this.contract.paid_value);
    },
  },
  methods: {
    ...mapActions([
      'loadStudentContracts',
    ]),
    executeCancel() {
      if (!this.observations) {
        this.inputError = 'É necessário informar o motivo do cancelamento';
        return;
      }
      this.$loader.show();
      ContractsService.cancelContract(this.contract.id, this.observations)
        .then(() => {
          this.$alert.notifySuccess('O contrato foi cancelado');
          this.loadStudentContracts(this.contract.student_id);
          this.$emit('close');
        })
        .catch(({ body }) => {
          this.$alert.notifyAlert(`Falha ao cancelar o contrato: ${body.message}`);
        })
        .finally(() => {
          this.$loader.hide();
        });
    },
  },
};
</script>
